var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGeneralReports(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 259,
    height: 193,
    viewBox: "0 0 259 193",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M0 169.41H259V170.41H0zM215.892 177.736H233.048V178.736H215.892zM138.751 173.736H152.923V174.736H138.751zM205.434 172.934H215.374V173.934H205.434zM27.174 173.804H36.058V174.804H27.174zM40.668 173.804H57.441V174.804H40.668zM85.356 175.987H116.62799999999999V176.987H85.356zM122.766 146.333H22.746c-1.632-.003-2.953-1.325-2.953-2.955V2.928C19.807 1.31 21.123.004 22.745 0h100.021c1.634 0 2.958 1.323 2.958 2.955v140.423c0 1.632-1.324 2.955-2.958 2.955zM22.746.103c-1.56.003-2.824 1.267-2.824 2.826v140.449c0 1.558 1.263 2.822 2.823 2.825h100.021c1.56-.003 2.825-1.266 2.828-2.825V2.928c-.003-1.558-1.267-2.822-2.828-2.825H22.746zM234.815 146.333H134.789c-1.633-.003-2.955-1.324-2.958-2.955V2.928c.017-1.62 1.335-2.925 2.958-2.928h100.026c1.619.006 2.933 1.311 2.947 2.929v140.449c0 1.628-1.318 2.949-2.947 2.955zM134.789.103c-1.561.003-2.826 1.267-2.828 2.826v140.449c.002 1.56 1.267 2.822 2.828 2.825h100.026c1.56-.003 2.825-1.266 2.828-2.825V2.928c-.003-1.558-1.268-2.822-2.828-2.825H134.789z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M33.333 94.702H42.113V167.051H33.333zM34.551 167.051H118.876V169.411H34.551z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M42.113 94.697H120.093V167.046H42.113z",
    transform: "rotate(180 81.103 130.871)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.771,
    height: 16.31,
    x: 49.22,
    y: 120.383,
    fill: "#F0F0F0",
    rx: 5.16,
    transform: "rotate(180 81.106 128.538)"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.771,
    height: 16.31,
    x: 49.22,
    y: 141.375,
    fill: "#F0F0F0",
    rx: 5.16,
    transform: "rotate(180 81.106 149.53)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M92.4 122.727H69.81c-.973-.003-1.76-.792-1.76-1.765.003-.97.79-1.756 1.76-1.759H92.4c.972.003 1.76.789 1.762 1.76 0 .972-.788 1.761-1.761 1.764z"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 63.771,
    height: 16.31,
    x: 49.22,
    y: 99.39,
    fill: "#F0F0F0",
    rx: 5.16,
    transform: "rotate(180 81.106 107.545)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M92.4 101.734H69.81c-.97-.003-1.757-.789-1.76-1.76.003-.97.79-1.756 1.76-1.758H92.4c.972.002 1.76.788 1.762 1.759-.003.97-.79 1.756-1.761 1.76zM92.4 143.714H69.81c-.97-.003-1.757-.789-1.76-1.759.003-.97.79-1.756 1.76-1.76H92.4c.972.004 1.76.79 1.762 1.76-.003.97-.79 1.756-1.761 1.76z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "M42.119 91.023H121.699V94.702H42.119z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M31.614 91.018H42.119V94.697H31.614z",
    transform: "rotate(180 36.866 92.858)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M35.514 8.538H217.17100000000002V69.493H35.514z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M36.705 8.538H219.72500000000002V69.493H36.705z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M35.514 69.492H154.975V72.519H35.514z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M48.076 69.492H223.492V72.519H48.076z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFA",
    d: "M101.487 -48.908L154.954 -48.908 154.954 126.943 101.487 126.943z",
    transform: "rotate(90 128.22 39.018)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M62.523 65.751L93.121 12.284 107.568 12.284 76.97 65.751zM80.072 65.751L110.671 12.284 116.301 12.284 85.703 65.751zM169.733 65.751L200.326 12.284 205.957 12.284 175.364 65.751z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M189.184 39.015L242.652 39.015 242.652 39.02 189.184 39.02z",
    transform: "rotate(90 215.918 39.018)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EBEBEB",
    d: "M220.575 16.62L38.917 16.62 38.591 13.738 220.243 13.738zM220.575 20.211L38.917 20.211 38.591 17.329 220.243 17.329zM220.575 23.808L38.917 23.808 38.591 20.925 220.243 20.925zM220.575 27.399L38.917 27.399 38.591 24.516 220.243 24.516zM220.575 30.995L38.917 30.995 38.591 28.113 220.243 28.113zM220.575 34.591L38.917 34.591 38.591 31.709 220.243 31.709zM220.575 38.182L38.917 38.182 38.591 35.3 220.243 35.3zM220.575 41.778L38.917 41.778 38.591 38.896 220.243 38.896zM220.575 45.369L38.917 45.369 38.591 42.487 220.243 42.487zM220.575 48.966L38.917 48.966 38.591 46.083 220.243 46.083zM220.575 52.557L38.917 52.557 38.591 49.674 220.243 49.674zM220.575 56.153L38.917 56.153 38.591 53.271 220.243 53.271zM220.575 59.749L38.917 59.749 38.591 56.862 220.243 56.862zM220.575 63.34L38.917 63.34 38.591 60.458 220.243 60.458z",
    opacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M211.432 140.196h-30.22l-2.88-49.99c-.049-.586.154-1.166.558-1.593.405-.428.972-.663 1.56-.648h25.714c1.255.014 2.289.99 2.372 2.24l2.896 49.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M214.478 140.196h-30.215l-2.88-49.99c-.049-.586.154-1.164.557-1.591.403-.427.969-.664 1.556-.65h25.73c1.255.014 2.288.99 2.372 2.24l2.88 49.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M184.869 133.96h21.036v6.21h-23.284v-3.995c.014-1.23 1.017-2.217 2.248-2.214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M201.269 133.96h26.78c1.24 0 2.243 1.004 2.243 2.241v3.995h-31.271V136.2c0-.595.237-1.166.659-1.586.421-.42.993-.656 1.589-.654z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M181.212 140.196H183.284V169.411H181.212zM196.42 140.196H198.492V169.411H196.42zM212.541 140.196H214.613V169.411H212.541zM227.744 140.196H229.816V169.411H227.744zM172.753 140.196h-30.215l-2.885-49.99c-.04-.584.167-1.157.57-1.583.401-.425.963-.664 1.548-.658h25.73c1.254.016 2.286.99 2.372 2.24l2.88 49.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M175.804 140.196h-30.22l-2.88-49.99c-.04-.584.165-1.159.568-1.584.402-.426.964-.664 1.55-.657h25.724c1.256.013 2.292.989 2.378 2.24l2.88 49.99z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M146.19 133.96h21.036v6.21h-23.279v-3.995c.014-1.227 1.014-2.215 2.243-2.214z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F5F5F5",
    d: "M162.59 133.96h26.78c1.24 0 2.243 1.004 2.243 2.241v3.995h-31.266V136.2c0-1.237 1.004-2.24 2.243-2.24z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E6E6E6",
    d: "M142.538 140.196H144.61V169.411H142.538zM157.741 140.196H159.81300000000002V169.411H157.741zM173.862 140.196H175.934V169.411H173.862zM189.065 140.196H191.137V169.411H189.065z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F5F5F5",
    transform: "translate(29 181)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 100.5,
    cy: 6.12,
    rx: 100.443,
    ry: 5.66
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#B55B52",
    d: "M19.535 153.463L15.591 152.101 17.7 142.648 21.645 144.01zM52.311 156.362L48.138 156.362 47.063 146.738 51.236 146.738z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M47.811 155.88h4.776c.17.001.317.12.353.285l.827 3.696c.038.182-.01.372-.13.515-.119.143-.297.224-.484.22-1.637-.026-2.827-.124-4.89-.124-1.268 0-4.781.135-6.532.135-1.752 0-1.98-1.724-1.263-1.885 3.212-.699 5.633-1.662 6.662-2.588.19-.164.43-.254.681-.254zM15.648 151.682l4.303 1.485c.161.055.263.215.244.384l-.437 3.758c-.014.187-.116.356-.274.457-.158.102-.354.124-.531.06-1.56-.564-3.757-1.428-5.717-2.101-2.281-.787-3.367-.958-6.044-1.88-1.616-.559-1.158-2.298-.426-2.262 3.337.182 4.59.808 7.822.088.347-.093.714-.09 1.06.01zM40.354 31.967c-1.185 1.263-2.339 2.412-3.555 3.567-1.216 1.154-2.443 2.262-3.716 3.36-2.58 2.252-5.342 4.29-8.258 6.093-.781.471-1.586.903-2.411 1.294-.42.207-.873.399-1.325.585l-.712.259c-.25.083-.52.16-.79.233-2.134.552-4.383.479-6.475-.212-1.874-.632-3.598-1.642-5.062-2.967-.685-.608-1.323-1.267-1.907-1.972-.291-.347-.567-.71-.827-1.077s-.488-.725-.764-1.18l2.87-2.17.82.653c.291.228.587.44.884.652.585.413 1.192.793 1.819 1.14 1.127.638 2.358 1.074 3.637 1.288 1.053.16 2.13.036 3.118-.357l.37-.155.415-.192c.286-.145.572-.285.873-.46.593-.327 1.19-.725 1.798-1.13 1.211-.817 2.417-1.744 3.602-2.722 1.185-.979 2.36-1.993 3.523-3.044 1.164-1.051 2.308-2.123 3.446-3.205 1.138-1.082 2.286-2.205 3.352-3.271l5.275 4.99z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B55B52",
    d: "M7.447 38.107L4.85 34.084 2.25 39.106s3.014 3.163 4.506 1.719l.691-2.718zM1.705 33.396L.307 36.932 2.209 39.106 4.828 34.084z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M17.7 142.653L16.614 147.525 20.559 148.886 21.645 144.01zM51.236 146.743L47.063 146.743 47.619 151.702 51.792 151.702z",
    opacity: 0.2,
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M57.617 31.807c-4.266 14.38-3.814 29.647-4.375 32.748-3.243-.43-17.15-2.459-23.828-3.354-1.04-16.66 2.994-27.82 4.823-32.775.732-1.99 2.589-3.348 4.713-3.448h.058c.613-.026 1.273-.041 1.959-.036h1.153c3.156.242 6.295.663 9.402 1.263.587.109 1.184.233 1.761.363.577.129 1.04.253 1.56.383h.067c1.019.265 1.885.934 2.396 1.85.511.918.624 2.004.311 3.006z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M46.304 36.533L46.252 37.278 51.147 38.086 51.303 37.475z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M42.12 24.968c-1.122 1.17-2.442 10.923-.805 15.453 2.765-4.571 8.315-12.782 10.201-14.19-3.105-.6-6.242-1.022-9.396-1.263z",
    opacity: 0.3,
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B55B52",
    d: "M52.015 15.562c-.998 2.93-2.338 8.37-.493 10.664-.697.683-3.586 1.258-6.237.854-2.177-.331-3.216-1.273-3.16-2.112 3.483-.352 3.732-2.858 3.462-5.275l6.428-4.131z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M49.37 17.244l-3.783 2.428c.07.565.09 1.135.062 1.703 1.315 0 3.274-1.185 3.596-2.51.138-.529.18-1.078.125-1.62z",
    opacity: 0.2,
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M42.968 13.496c-.582-1.315-.8-3.877.296-7.18.894-2.692 3.726-1.822 5.685-1.351 1.96.47 1.237 3.106-.187 5.026-1.528 2.045-5.794 3.505-5.794 3.505z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B55B52",
    d: "M54.317 11.415c-1.195 3.95-1.688 6.32-4.209 7.9-3.783 2.376-8.315-.621-8.315-4.846 0-3.805 1.938-9.623 6.236-10.291 1.933-.313 3.89.395 5.172 1.87 1.282 1.475 1.704 3.506 1.116 5.367z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M51.63 15.53c-.696-1.257-.976-4.565-.311-7.175.52-1.977 3.752-2.428 5.545-1.511 2.136 1.092 1.736 3.235.13 4.985-1.736 1.895-5.363 3.702-5.363 3.702z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M56.438 8.055c1.6-.093 2.66-2.21 1.361-3.225-1.528-1.19-3.637 0-5.56-2.635-1.804-2.475-6.278-2.904-7.962-.683-.966 1.278-.104 1.79-2.697 3.344-1.512.906-1.04 2.443-.65 3.2-.041-.57.198-2.035 1.606-2.351 1.18-.264 1.876.75 2.687-.16 0 0 2.744 2.51 7.94 2.909 2.895.222 3.275-.399 3.275-.399z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B55B52",
    d: "M55.087 16.255c-.743.727-1.744 1.133-2.786 1.129-1.377 0-1.678-1.346-.972-2.438.64-.984 2.126-2.164 3.357-1.616 1.232.55 1.305 2.025.4 2.925z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M15.45 146.106l6.678 2.299s6.538-25.667 8.585-38.454c.624-3.893 2.017-9.277 3.7-15.013 2.126-7.247 4.678-15.054 6.803-21.168 2.209-6.44 3.867-10.99 3.867-10.99L30.53 60.828s-9.712 32.92-11.433 45.489c-1.74 13.056-3.648 39.79-3.648 39.79z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M34.414 94.928c2.125-7.248 4.677-15.054 6.802-21.168l-1.304-3.355c-3.903 4.059-5.732 17.27-5.498 24.523z",
    opacity: 0.2,
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M38.39 61.869s-.718 35.606.264 47.74c1.07 13.29 7.037 41.136 7.037 41.136h7.644s-1.065-25.543-2.63-38.449c-1.782-14.702 1.955-48.512 1.955-48.512l-14.27-1.915z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M44.776 150.905L53.777 150.905 53.777 148.229 44.168 148.058zM14.556 145.972L22.513 148.715 23.401 146.158 14.92 142.653zM47.951 11.104c-.078.326-.311.55-.52.518-.207-.031-.327-.352-.249-.678.078-.326.312-.549.52-.518.208.031.327.352.25.678zM44.251 10.235c-.078.326-.312.554-.52.517-.207-.036-.322-.357-.244-.683.078-.326.312-.549.52-.518.208.031.322.357.244.684z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A02724",
    d: "M45.39 10.675c-.627.905-1.375 1.72-2.225 2.422.378.428.925.669 1.497.658l.727-3.08z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M45.836 14.956c.751.078 1.502-.152 2.079-.637.04-.037.042-.1.005-.14-.037-.04-.1-.042-.14-.005-.657.537-1.532.73-2.354.518-.026-.006-.053-.002-.075.011-.023.014-.039.036-.045.061-.01.053.021.104.073.12.171.03.317.056.457.072zM49.37 10.178c.032.01.067.01.099 0 .048-.02.086-.06.105-.109.018-.049.016-.103-.006-.15-.244-.585-.757-1.016-1.378-1.155-.051-.009-.104.003-.147.033-.043.03-.072.076-.081.128-.016.108.058.21.166.228.49.117.892.462 1.081.926.033.059.094.096.161.099zM42.952 8.594c.067.007.134-.02.177-.073.305-.399.785-.626 1.288-.61.052.005.104-.01.145-.044.04-.033.065-.08.069-.133.009-.106-.066-.201-.172-.217-.638-.023-1.248.262-1.637.766-.034.04-.05.093-.046.145.005.053.03.101.072.135.031.02.067.03.104.03z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M46.423 156.61c.369-.01.735-.06 1.092-.15.04-.01.07-.042.078-.083.003-.039-.015-.076-.047-.098-.15-.093-1.497-.917-1.96-.684-.103.055-.17.163-.17.28-.02.196.058.389.207.518.235.16.517.236.8.217zm.806-.29c-.707.14-1.252.114-1.481-.078-.102-.086-.153-.219-.135-.352-.003-.048.02-.094.062-.119.24-.124 1.008.233 1.554.57v-.02z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M47.494 156.46c.017.005.035.005.052 0 .03-.02.047-.053.047-.088 0-.052-.104-1.253-.593-1.646-.115-.102-.269-.147-.42-.125-.152 0-.283.106-.312.254-.089.466.748 1.377 1.18 1.61l.046-.005zm-.842-1.672c.083 0 .163.03.224.088.293.373.466.826.493 1.3-.426-.327-.961-1.036-.91-1.285 0-.026 0-.088.146-.103h.047zM15.07 152.065c.038 0 .072-.02.09-.052.022-.035.022-.08 0-.114-.146-.15-1.456-1.501-2.028-1.398-.107.02-.197.092-.239.192-.085.162-.085.355 0 .518.302.517 1.487.766 2.162.859l.016-.005zm-1.88-1.372c.332 0 1.08.621 1.6 1.134-.92-.156-1.559-.42-1.72-.715-.057-.105-.057-.231 0-.336.012-.044.049-.076.094-.083h.026z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M15.07 152.065h.027c.034-.012.061-.038.073-.073 0-.046.27-1.139-.089-1.724-.101-.17-.268-.292-.462-.336-.265-.062-.385.041-.437.14-.228.419.421 1.589.821 1.967.018.018.043.027.068.026zm-.597-1.936h.099c.143.031.265.122.338.248.18.44.216.926.104 1.388-.385-.456-.795-1.346-.66-1.595.028-.035.075-.051.12-.041z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#263238",
    d: "M56.386 27.774c.556.745 1.04 1.408 1.507 2.127.468.72.935 1.419 1.393 2.139.904 1.439 1.754 2.921 2.551 4.446.813 1.543 1.543 3.128 2.188 4.748.696 1.702 1.229 3.467 1.59 5.27.094.476.167.968.224 1.465 0 .036 0 .191.031.29.031.098 0 .227 0 .326v.6c-.026.348-.075.694-.145 1.036-.245 1.054-.632 2.071-1.149 3.023-.852 1.586-1.849 3.09-2.978 4.493-1.075 1.357-2.193 2.63-3.357 3.847-1.164 1.216-2.36 2.376-3.664 3.5l-2.681-2.398c1.751-2.66 3.56-5.363 5.087-8.055.748-1.269 1.4-2.59 1.954-3.955.209-.512.352-1.047.427-1.594.009-.06.009-.121 0-.181 0 0 0 .046 0 0-.068-.306-.135-.617-.229-.937-.404-1.37-.914-2.706-1.523-3.997-.639-1.346-1.34-2.708-2.11-4.048-.769-1.341-1.559-2.672-2.406-3.997-.416-.656-.84-1.311-1.273-1.967l-1.284-1.9 5.847-4.281z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B55B52",
    d: "M53.008 62.23l-4.158 1.264 3.732 3.945s3.175-1.885 2.36-3.67l-1.934-1.538z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B55B52",
    d: "M47.161 66.491L50.176 69.504 52.603 67.439 48.871 63.499z",
    transform: "translate(129 26)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M37.802 62.588s.795-5.394 2.172-8.019c.286 2.299 1.253 8.34 1.253 8.34l-3.425-.32z",
    opacity: 0.3,
    transform: "translate(129 26)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M0.55 13.037L1.067 13.038 1.068 25.396 0.551 25.396z",
    transform: "translate(46 22) rotate(-1.11 .81 19.217)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M0.799 29.353L1.316 29.353 1.317 34.668 0.8 34.667z",
    transform: "translate(46 22) rotate(-1.11 1.058 32.01)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M102.96 0.458L1.991 0.458 4.648 137.83 105.617 137.83z",
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M97.406 4.979L8.196 4.979 10.678 132.974 99.883 132.974z",
    opacity: 0.8,
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M97.391 4.336L8.185 4.336 11.81 132.326 101.021 132.326z",
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M34.065 30.54l4.783-14.191c6.045 2.175 10.154 7.794 10.377 14.191.234 7.263-4.92 13.596-12.104 14.871l-3.056-14.87z",
    opacity: 0.2,
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M34.065 30.54l3.056 14.871c-.868.15-1.747.226-2.627.227-8.41-.085-15.27-6.73-15.59-15.098-.116-3.964 1.385-7.805 4.16-10.649 2.776-2.843 6.59-4.446 10.572-4.443 1.777.002 3.54.31 5.212.911L34.065 30.54z",
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M71.873 30.54l-.377-15.092c4.039.03 7.91 1.615 10.801 4.423 6.05 5.86 6.324 15.5.605 21.354-5.718 5.855-15.393 5.86-21.443 0-2.256-2.18-3.802-4.987-4.436-8.054l14.85-2.63z",
    opacity: 0.2,
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M71.873 30.54l-14.855 2.621c-.986-4.529.242-9.255 3.31-12.74 3.067-3.485 7.61-5.316 12.248-4.937l-.703 15.056zM90.519 120.523L20.781 120.523 19.866 88.371 20.419 88.366 21.314 119.972 90.503 119.972z",
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M90.488 119.627c.343.003.622.277.63.618.006.163-.055.321-.17.438-.114.117-.27.182-.434.18-.346 0-.628-.274-.636-.618-.003-.163.06-.32.175-.436.114-.116.271-.182.435-.182zM20.766 88.392c-.014-.342-.297-.613-.642-.613-.163.002-.318.069-.431.186-.113.117-.174.275-.168.437.008.343.291.616.636.613.164 0 .32-.066.435-.184.114-.117.175-.276.17-.439zM23.232 118.402L22.834 118.016 31.071 109.576 35.993 109.576 38.248 107.269 45.337 107.269 60.151 92.089 63.647 92.089 68.719 97.002 71.873 97.002 81.139 87.506 89.583 87.506 89.593 88.052 81.382 88.052 72.116 97.547 68.502 97.547 63.429 92.635 60.389 92.635 45.575 107.815 38.486 107.815 36.236 110.127 31.309 110.127z",
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M23.506 118.623c-.178.18-.448.235-.683.14-.234-.097-.388-.325-.388-.577 0-.253.154-.48.388-.577.235-.096.505-.04.683.139.24.243.24.633 0 .875zM89.573 88.397c.163 0 .319-.065.433-.182.114-.116.176-.273.172-.436-.009-.341-.288-.615-.631-.618-.164 0-.32.066-.435.182-.115.116-.178.273-.175.436.01.343.291.616.636.618z",
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#0C5BAB",
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.91 18.038L0.512 17.652 10.341 7.575 18.413 7.575 23.884 12.878 30.001 12.878 35.342 7.399 42.209 7.399 44.448 5.108 51.071 5.108 55.627 0.438 57.86 0.438 68.259 10.515 67.881 10.901 57.643 0.989 55.865 0.989 51.309 5.659 44.691 5.659 42.452 7.95 35.58 7.95 30.238 13.424 23.672 13.424 18.196 8.126 10.584 8.126z",
    transform: "translate(46 22) translate(22.234 97.32)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.184 18.254c-.178.181-.448.238-.684.142-.235-.095-.39-.324-.39-.577 0-.253.155-.482.39-.577.236-.096.506-.04.684.142.117.115.182.272.182.435 0 .163-.065.32-.182.435zM67.618 11.128c.241.235.629.233.867-.006.238-.24.238-.625 0-.864s-.626-.242-.867-.006c-.24.243-.24.633 0 .876z",
    transform: "translate(46 22) translate(22.234 97.32)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M26.8 62.291L19.406 62.291 19.194 54.927 26.588 54.927z",
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M64.872 59.942L31.154 59.942 31.076 57.275 64.794 57.275zM87.846 59.942L69.086 59.942 69.009 57.275 87.768 57.275zM50.88 71.559L31.479 71.559 31.407 68.892 50.802 68.892zM79.521 71.559L55.094 71.559 55.017 68.892 79.448 68.892z",
    transform: "translate(46 22)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0C5BAB",
    d: "M27.126 73.907L19.732 73.907 19.525 66.544 26.919 66.544z",
    opacity: 0.2,
    transform: "translate(46 22)"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#E0E0E0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.647 0.338L43.529 24.612 42.991 25.563 0.393 0.79z",
    transform: "translate(134 66)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralReports);
export default __webpack_public_path__ + "static/media/general_reports.8ecc9b78788ba1c84394258cc7bdb6ad.svg";
export { ForwardRef as ReactComponent };